import { Cryptocurrency } from '__generated__/globalTypes';
import { useIntlContext } from 'contexts/intl';
import { SOL_DECIMAL_PLACES, toLamport } from 'lib/lamport';
import { ETH_DECIMAL_PLACES, toWei } from 'lib/wei';

import { useMonetaryAmount } from './useMonetaryAmount';

const MAXIMUM_FRACTION_DIGITS = {
  [Cryptocurrency.LAMPORT]: SOL_DECIMAL_PLACES,
  [Cryptocurrency.WEI]: ETH_DECIMAL_PLACES,
};

export const useCryptoAmount = (cryptocurrency: Cryptocurrency) => {
  const { lamport, wei } = useMonetaryAmount();
  const { formatLamport, formatWei, formatSol, formatEth } = useIntlContext();

  const {
    formatCryptoAmount,
    getCryptoAmount,
    toSubUnitAmount,
    formatCryptoMajor,
  } = (() => {
    switch (cryptocurrency) {
      case Cryptocurrency.LAMPORT:
        return {
          getCryptoAmount: lamport,
          formatCryptoAmount: formatLamport,
          formatCryptoMajor: formatSol,
          toSubUnitAmount: toLamport,
        };
      case Cryptocurrency.WEI:
      default:
        return {
          getCryptoAmount: wei,
          formatCryptoAmount: formatWei,
          formatCryptoMajor: formatEth,
          toSubUnitAmount: toWei,
        };
    }
  })();

  return {
    getCryptoAmount,
    formatCryptoAmount,
    toSubUnitAmount,
    formatCryptoMajor,
    maximumFractionDigits: MAXIMUM_FRACTION_DIGITS[cryptocurrency],
  };
};
